import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ElementRef,
  ViewChild,
  OnDestroy,
  OnChanges,
} from '@angular/core'
import { getSettingsState } from '@containers/settings/settings.selectors'
import { select, Store } from '@ngrx/store'
import { TranslateService } from '@ngx-translate/core'
import { Feature, Map, Overlay, View } from 'ol'
import { Coordinate } from 'ol/coordinate'
import { Geometry, Point } from 'ol/geom'
import ImageLayer from 'ol/layer/Image'
import VectorLayer from 'ol/layer/Vector'
import { ImageWMS } from 'ol/source'
import VectorSource from 'ol/source/Vector'
import { Icon, Style } from 'ol/style'
import { Subscription } from 'rxjs'

@Component({
  selector: 'lng-lat-picker',
  templateUrl: './lng-lat-picker.component.html',
  styleUrls: ['./lng-lat-picker.component.css'],
})
export class LngLatPickerComponent implements OnInit, OnDestroy, OnChanges {
  @Input() public value: Coordinate
  @Output() public onPick: EventEmitter<any> = new EventEmitter()

  public isMapVisible = false
  public map: Map
  public vector: VectorLayer<any>
  public streetsLayer: VectorLayer<any>
  public raster: ImageLayer<any>
  public settings: any
  private settings$: Subscription
  public extent: any
  public position: Coordinate = []
  public overlay: Overlay
  public pointFeature: Feature
  private iconStyle = new Style({
    image: new Icon({
      anchor: [0.5, 50],
      anchorXUnits: 'fraction',
      anchorYUnits: 'pixels',
      src: 'https://i.imgur.com/48Uy373.png',
    }),
  })
  public source: any

  @ViewChild('olPopup', { static: false }) popup: ElementRef

  constructor(
    public store: Store<any>,
    private translateService: TranslateService,
  ) {}

  updatePointFeature(fit?: boolean) {
    if (this.pointFeature) {
      this.source.removeFeature(this.pointFeature)
    }

    if (this.position && this.position[0] && this.position[1]) {
      this.pointFeature = new Feature({
        geometry: new Point(this.position),
      })
      this.pointFeature.setStyle(this.iconStyle)
      this.source.addFeature(this.pointFeature)

      if (fit) {
        this.map.getView().fit(this.pointFeature.getGeometry().getExtent(), {
          size: this.map.getSize(),
          padding: [20, 20, 20, 20],
          maxZoom: 18,
        })
      }
    }
  }

  ngOnChanges(changes: any) {
    if (
      JSON.stringify(changes.value.previousValue) !==
        JSON.stringify(changes.value.currentValue) &&
      this.map
    ) {
      this.position = changes.value.currentValue

      this.updatePointFeature(true)
    }
  }

  ngOnInit() {
    this.settings$ = this.store
      .pipe(select(getSettingsState))
      .subscribe((state) => {
        this.settings = state.get('data')
        if (this.settings.size && !this.map) {
          this.initMap()
        }
      })
  }
  setOpacity = (hex: string, alpha: number) =>
    hex
      ? `${hex}${Math.floor(alpha * 255)
          .toString(16)
          .padStart(2)}`
      : null

  initMap() {
    const _this = this
    const {
      GIS_GEOSERVER_URL,
      GIS_GEOSERVER_WORKSPACE,
      GIS_BASE_LAYER,
      GIS_MAP_EXTENT,
    } = this.settings.toJS().gis
    // this.overlay = new Overlay({
    //   element: this.popup.nativeElement,
    //   offset: [-128, 20],
    //   autoPan: false,
    // })

    const extent = GIS_MAP_EXTENT.split(',').map((c: string) => parseFloat(c))
    const origin = extent[0] + ',' + extent[1]

    this.source = new VectorSource({
      features: [],
    })

    this.vector = new VectorLayer({
      source: this.source,
      zIndex: 100,
    })

    this.raster = new ImageLayer({
      source: new ImageWMS({
        url: `${GIS_GEOSERVER_URL}/${GIS_GEOSERVER_WORKSPACE}/wms`,
        params: {
          FORMAT: 'image/jpeg',
          VERSION: '1.1.1',
          tiled: true,
          LAYERS: `${GIS_GEOSERVER_WORKSPACE}:${GIS_BASE_LAYER}`,
          exceptions: 'application/vnd.ogc.se_inimage',
          tilesOrigin: origin,
        },
      }),
    })

    this.map = new Map({
      layers: [this.raster, this.vector],
      target: 'ol-layer',
      view: new View({
        projection: 'EPSG:4326',
        center: this.value?.length
          ? this.value
          : [(extent[0] + extent[2]) / 2, (extent[1] + extent[3]) / 2],
        zoom: 14,
      }),
    })

    if (this.value && this.value?.length) {
      this.position = this.value

      this.updatePointFeature(true)
    }

    this.map.on('click', ({ coordinate }) => {
      this.position = coordinate

      this.updatePointFeature()
    })
  }

  ngOnDestroy(): void {
    this.settings$.unsubscribe()
  }

  onSave() {
    this.onPick.emit(this.position)

    this.isMapVisible = false
  }
}
